import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const GorgiasKnowledgeRating_ = z.object({ up: z.number(), down: z.number() });
export const GorgiasKnowledgeRating: z.ZodType<GorgiasKnowledgeRating> =
  GorgiasKnowledgeRating_;
export interface GorgiasKnowledgeRating extends z.infer<
  typeof GorgiasKnowledgeRating_
> {}

const GorgiasKnowledgeSeoMeta_ = z.object({
  title: z.string().nullable(),
  description: z.string().nullable(),
});
export const GorgiasKnowledgeSeoMeta: z.ZodType<GorgiasKnowledgeSeoMeta> =
  GorgiasKnowledgeSeoMeta_;
export interface GorgiasKnowledgeSeoMeta extends z.infer<
  typeof GorgiasKnowledgeSeoMeta_
> {}

const GorgiasKnowledgeTranslation_ = z.object({
  locale: z.string(),
  created_datetime: z.string(),
  updated_datetime: z.string(),
  deleted_datetime: z.string().nullable(),
  article_id: z.number(),
  category_id: z.number().nullable(),
  title: z.string(),
  excerpt: z.string(),
  content: z.string(),
  slug: z.string(),
  seo_meta: GorgiasKnowledgeSeoMeta,
  is_current: z.boolean(),
  visibility_status: z.enum(["PUBLIC", "UNLISTED"]),
  draft_version_id: z.number(),
  published_version_id: z.number(),
  article_unlisted_id: z.string(),
  rating: GorgiasKnowledgeRating,
});
export const GorgiasKnowledgeTranslation: z.ZodType<GorgiasKnowledgeTranslation> =
  GorgiasKnowledgeTranslation_;
export interface GorgiasKnowledgeTranslation extends z.infer<
  typeof GorgiasKnowledgeTranslation_
> {}

const GorgiasKnowledgeArticle_ = z.object({
  id: z.number(),
  created_datetime: z.string(),
  updated_datetime: z.string(),
  deleted_datetime: z.string().nullable(),
  category_id: z.number().nullable(),
  help_center_id: z.number(),
  template_key: z.string().nullable(),
  origin: z.string().nullable(),
  ingested_resource_id: z.number().nullable(),
  available_locales: z.array(z.string()),
  rating: GorgiasKnowledgeRating,
  translation: GorgiasKnowledgeTranslation,
  unlisted_id: z.string(),
});
export const GorgiasKnowledgeArticle: z.ZodType<GorgiasKnowledgeArticle> =
  GorgiasKnowledgeArticle_;
export interface GorgiasKnowledgeArticle extends z.infer<
  typeof GorgiasKnowledgeArticle_
> {}

const GorgiasKnowledgeResponse_ = z.object({
  object: z.literal("list"),
  data: z.array(GorgiasKnowledgeArticle),
});
export const GorgiasKnowledgeResponse: z.ZodType<GorgiasKnowledgeResponse> =
  GorgiasKnowledgeResponse_;
export interface GorgiasKnowledgeResponse extends z.infer<
  typeof GorgiasKnowledgeResponse_
> {}

export const importGorgiasKnowledge = {
  name: "importGorgiasKnowledge" as const,
  input: z.object({
    teamId: zExt.objectId(),
    gorgiasKnowledgeJson: GorgiasKnowledgeResponse,
  }),
  output: z.object({
    success: z.boolean(),
    knowledgeCreated: z.number(),
    knowledgeSkipped: z.number(),
    errors: z.array(z.string()).optional(),
  }),
};
